import { Table } from "reactstrap";
import BaseParagraph from "../baseComponents/baseParagraph";
import { useSelector, useDispatch } from "react-redux";
import useColors from "../customHooks/useColors";

import { useState, useEffect } from "react";
import BaseButton from "../baseComponents/baseButton";
import { Container, Row, Col } from "reactstrap";
import useBootstrap from "../customHooks/useBootstrap";
import AddModal from "../utilComponents/AddModal";

import TransactionDetails from "./TransactionDetails";
import MessageDetails from "./MessageDetails";
import { asyncActions as userAsyncActions } from "../store/slices/userSlice";

const formatDateTime = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // getMonth() returns month from 0-11
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${day}.${month}.${year}. ${hours}:${minutes}`;
};

const MessagesTable = () => {
  const dispatch = useDispatch();
  const userState = useSelector((state) => state.userState);

  const [messageSeen, setMessageSeen] = useState(false);

  const userMessagesList = userState.messages;
  const transactions = userState.points;
  const numberOfTransactions = transactions.length;
  const numberOfMessages = userMessagesList.length;

  const { trashold8 } = useBootstrap();

  const [pointsSelectedId, setPointsSelectedId] = useState(null);
  const [selectedMessageID, setSelectedMessageID] = useState(null);

  const [currentColors] = useColors();

  useEffect(() => {
    dispatch(userAsyncActions.getUserInfo());
  }, [messageSeen]);

  const VMessagesTable = ({ openModal }) => (
    <Container fluid>
      <Row>
        <Col {...trashold8}>
          <div
            style={{
              backgroundColor: currentColors.septenary,
              margin: "20px 0",
              padding: "8px",
            }}
          >
            <Table
              responsive
              style={{
                backgroundColor: currentColors.septenary,
                margin: "auto 0",
              }}
            >
              <thead>
                <tr>
                  <th style={{ width: "150px" }}>
                    <BaseParagraph
                      style={{ color: currentColors.tertiary }}
                      bold
                    >
                      date
                    </BaseParagraph>
                  </th>
                  <th>
                    <BaseParagraph
                      style={{ color: currentColors.tertiary }}
                      bold
                      translate={false}
                    >
                      Naslov poruke
                    </BaseParagraph>
                  </th>
                </tr>
              </thead>
              <tbody>
                {userMessagesList
                  .filter((message) => message.subject) // Filter out messages with empty or null subjects
                  .map((message) => {
                    const vOnClick = () => {
                      setSelectedMessageID(message.id);
                      openModal();
                    };
                    return (
                      <tr
                        style={{
                          cursor: "pointer",
                        }}
                        key={message.id}
                        onClick={vOnClick}
                      >
                        <td style={{ color: currentColors.tertiary }}>
                          <BaseParagraph
                            style={{
                              color: currentColors.primary,
                            }}
                            bold={message.seen == "N"}
                            translate={false}
                          >
                            {formatDateTime(message.sent)}
                          </BaseParagraph>
                        </td>
                        <td>
                          <BaseParagraph
                            style={{
                              color: currentColors.primary,
                            }}
                            bold={message.seen == "N"}
                            translate={false}
                          >
                            {message.subject}
                          </BaseParagraph>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </Table>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                paddingTop: "10px",
              }}
            >
              {numberOfMessages === 0 && (
                //TODO: add translate "noMessages", on mobile too
                <BaseParagraph translate={false}>Nema poruka</BaseParagraph>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );

  const ModalConent = () => (
    <MessageDetails
      selectedMessageID={selectedMessageID}
      onMessageSeen={() => setMessageSeen(!messageSeen)}
    />
  );

  return (
    <AddModal
      Component={VMessagesTable}
      ModalContent={ModalConent}
      ModalHeader={() => (
        <>
          <BaseParagraph bold translate={false}>
            {
              userMessagesList.find((msg) => msg.id === selectedMessageID)
                ?.subject
            }
          </BaseParagraph>
          <br />
          <BaseParagraph translate={false} style={{ fontSize: 18 }}>
            {formatDateTime(
              userMessagesList.find((msg) => msg.id === selectedMessageID)?.sent
            )}
          </BaseParagraph>
        </>
      )}
    />
  );
};

export default MessagesTable;
